import { GetWalletResponse } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPWalletState = (): Promise<GetWalletResponse> => {
    return new Promise<GetWalletResponse>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/wallet`).then((response) => {
            resolve(response.data as GetWalletResponse);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};